import Modal from "../../CommonComponents/common/modal/Modal";
import DataTable from "../../CommonComponents/common/datatable/DataTable";
import { Box, CircularProgress } from "@mui/material";

const TrackAccessRequestModal = ({ open, handleClose, rows = [], columns = [], loading }) => {
  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title="Request Details"
      initialWidth = {1300}
      initialHeight = {600}
      content={
        loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
            <CircularProgress size={40} sx={{ color: '#7d7c7cff' }} />
          </Box>
        ) : (
          <DataTable
            columns={columns}
            rows={rows}
            height="100%"
            defaultPageSize={10}
          />
        )
      }
      action={
        <Box display="flex" justifyContent="flex-end" width="100%">
          <button className="btn btn-primary" onClick={handleClose}>
            Close
          </button>
        </Box>
      }
    />
  );
};

export default TrackAccessRequestModal;